import {addOrRemoveHiddenTeamIdInput, updateTeamIdsOnPaginationLinks} from './../orgs/invitations'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'
import {onInput} from './../onfocus'

on('click', '.js-repo-toggle-team', async function ({currentTarget}) {
  //update the url of each pagination link (next/prev) to include the set of selected team_ids
  updateTeamIdsOnPaginationLinks('.js-repo-team-suggestions-pagination', '.js-repo-toggle-team')

  const checkBox = currentTarget as HTMLInputElement
  addOrRemoveHiddenTeamIdInput(checkBox, 'form.js-repository-teams')
})

onInput('.js-synced-repo-owner-input', function (event) {
  const input = event.target as HTMLInputElement
  const syncName = input.getAttribute('data-sync')
  if (!syncName) {
    return
  }

  const syncedElements = document.querySelectorAll(`[data-sync-with="${syncName}"]`)
  for (const syncedElement of syncedElements) {
    syncedElement.textContent = input.value
  }
})

on('click', '.js-repo-change-visibility-button', function ({currentTarget}) {
  const form = currentTarget.closest('form') as HTMLElement
  const modal = form.querySelector('.js-repo-change-visibility-modal') as HTMLElement

  modal.addEventListener(
    'cancel',
    () => {
      resetModal(modal)
    },
    {once: true}
  )
  modal.addEventListener(
    'close',
    () => {
      resetModal(modal)
    },
    {once: true}
  )
})

on('click', '.js-repo-visibility-proceed-button', function ({currentTarget}) {
  const button = currentTarget as HTMLButtonElement
  const nextStage = button.getAttribute('data-next-stage')!
  const newVisibility = button.getAttribute('data-new-visibility')!

  if (nextStage && newVisibility) {
    transitionModalTo(newVisibility, nextStage)
  }
})

onInput('.js-repo-visibility-proceed-confirmation', function ({currentTarget}) {
  const input = currentTarget as HTMLInputElement
  const numberOfStars = parseInt(input.getAttribute('data-number-of-stars')!, 10)
  const newVisibility = input.getAttribute('data-new-visibility')!
  const repoNwo = input.getAttribute('data-repo-nwo')!

  if (newVisibility && repoNwo) {
    const button = document.getElementById(`repo-visibility-proceed-button-${newVisibility}`) as HTMLButtonElement

    let proceed = false

    if (newVisibility === 'public') {
      proceed = input.value === repoNwo
    } else {
      proceed = numberOfStars === parseInt(input.value.replace(/[^0-9]+/g, ''), 10)
    }

    if (button && proceed) {
      const form = input.closest('form') as HTMLFormElement

      if (form) {
        addHiddenFormInput(form, 'visibility', newVisibility)
        addHiddenFormInput(form, 'verify', repoNwo)
        button.disabled = false
      }
    } else {
      button.disabled = true
    }
  }
})

function resetModal(modal: HTMLElement) {
  const newVisibility = modal.getAttribute('data-new-visibility')!

  if (newVisibility) {
    transitionModalTo(newVisibility, '1')
  }
}

function addHiddenFormInput(form: HTMLFormElement, name: string, value: string) {
  const newInput = document.createElement('input')
  newInput.setAttribute('type', 'hidden')
  newInput.setAttribute('name', name)
  newInput.setAttribute('value', value)

  form.appendChild(newInput)
}

function transitionModalTo(newVisibility: string, stage: string) {
  const replacementWarningTemplate = document.getElementById(
    `change-repository-visibility-${newVisibility}-step-${stage}`
  ) as HTMLTemplateElement
  const replacementButtonTemplate = document.getElementById(
    `proceed-button-visibility-${newVisibility}-step-${stage}`
  ) as HTMLTemplateElement

  if (replacementWarningTemplate && replacementButtonTemplate) {
    const replacementButtonTemplateClone = replacementButtonTemplate.content.cloneNode(true)
    const replacementWarningTemplateClone = replacementWarningTemplate.content.cloneNode(true)

    const warningContainer = document.getElementById(
      `repo-visibility-warning-${newVisibility}-container`
    ) as HTMLDivElement
    const existingButtonContainer = document.getElementById(
      `repo-visibility-proceed-button-${newVisibility}-container`
    ) as HTMLDivElement

    if (warningContainer && existingButtonContainer) {
      warningContainer.textContent = ''
      existingButtonContainer.textContent = ''
      warningContainer.appendChild(replacementWarningTemplateClone)
      existingButtonContainer.appendChild(replacementButtonTemplateClone)
    }
  }
}
